<template lang="pug">
  #home2
    Modal
    Header(@scrollTo="scrollToSection")#header
    Approach#solutions
    StakeHolderTask#use-cases
    Processes#benefits
    Finisher
    Footer
</template>

<script>
import Modal from '@/components/Shared/Modal.vue'
import Approach from '@/components/Home/Approach.vue'
import Finisher from '@/components/Shared/Finisher.vue'
import Footer from '@/components/Shared/Footer.vue'
import Header from '@/components/Home/Header.vue'
import Processes from '@/components/Home/Processes.vue'
import StakeHolderTask from '@/components/Home/StakeHolderTask.vue'
import VueScrollTo from 'vue-scrollto'

export default {
  name: 'Home',
  components: {
    Modal,
    Approach,
    Finisher,
    Footer,
    Header,
    Processes,
    StakeHolderTask
  },
  data(){
    return{
      activeSection: '',
      // whatWeDoSubsection: 0,
      ignoreScrollHandle: false,
      lastYScroll: 0,
      prefillContactMessage: '',
      timer: null,
      duo:[
        { name: 'Home', link: '/home' },
      ],
      trio:[
        {
          title: 'Target Identification',
          text: 'Identify comprehensive lists of targets matching detailed criteria. Keep track of the latest news and developments.',
          image: '@/assets/imagesnew/Icon Target.svg'
        }
      ],
      sections: [
        'header',
        'solutions',
        'stakeholder-task'
      ],
      scrollOptions: {
        container: 'body',
        easing: 'ease-in',
        cancelable: false,
        x: false,
        y: true
      }
    }

  },
  computed: {
    currentSection () {
        return this.$route.query.section || undefined
    }
  },
  mounted() {
    this.scrollToSection('#' + this.$route.query.section)
  },
  watch: {
    currentSection () {
      this.scrollToSection('#' + this.currentSection)
    }
  },
  methods: {
    scrollToSection (section) {
      VueScrollTo.scrollTo(section, 500, this.scrollOptions)
    }
  }    
}
  
</script>

<style scoped lang="scss">


</style>
